import React, { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import {
  CardCurrenyType,
  OrderDeliveryType,
  OrderType,
} from '../../constants/fieldValues.constant'
import CompanyInfoForm from './blocks/CompanyInfoForm'
import OrderFormFooter from './blocks/OrderFormFooter'
import { Row } from 'antd'
import UserInformation from './blocks/UserInformation'
import { BusinessCardFormSchema } from '../../models/businessCardOrder.schema'
import { OrderBusinessCardType } from '@app/store/reducers/salaryCards/businessCardOrder.api'

const DEFAULT_VALUES: OrderBusinessCardType = {
  trustedPerson: {
    id: null,
    fullName: '',
    phone: '',
    pin: '',
    expiryDate: '',
  },
  cardCurrency: CardCurrenyType.AZN,
  orderType: OrderType.ORDINARY,
  orderDeliveryType: OrderDeliveryType.BANK,
  frontFileId: null,
  cardHolder: {
    isMe: false,
    cardHolderFullName: '',
    phoneNumber: '',
    pin: '',
    serialType: 'AZE',
    serialNo: null,
    mobileOperatorName: undefined,
  },
  commission: {
    issueFee: 0,
    preparationFee: 0,
    totalFee: 0,
  },
}

function BusinessCardOrderForm() {
  const methods = useForm<OrderBusinessCardType>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    resolver: yupResolver(BusinessCardFormSchema),
    defaultValues: DEFAULT_VALUES,
  })

  const { trigger } = methods

  useEffect(() => {
    trigger()
  }, [])

  return (
    <FormProvider {...methods}>
      <Row
        style={{ flexDirection: 'column', marginBottom: 20 }}
        gutter={[0, 20]}
      >
        <CompanyInfoForm />
      </Row>
      <UserInformation />
      <OrderFormFooter type="create" />
    </FormProvider>
  )
}

export default BusinessCardOrderForm
